import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper';
import CardCompany from '../CardCompany';
import 'swiper/css';
import 'swiper/css/pagination';
import { Container } from 'react-bootstrap';

const SimilarCompanies = ({ data }) => {
    
    if (!data || data.length === 0) {
        return null;
    }

    return (
        <div className="similar-companies">
            <Container className="similar-companies-container">
                <h2 className="mb-4 h4">Companies people also viewed</h2>
                <Swiper
                    className="similar-companies-swiper"
                    modules={[Pagination]}
                    spaceBetween={30}
                    slidesPerView={4}
                    pagination={{ clickable: true, dynamicBullets: true, el: '.swiper-pagination-custom' }}
                    breakpoints={{
                        320: { slidesPerView: 1 },
                        768: { slidesPerView: 2 },
                        992: { slidesPerView: 3 },
                        1200: { slidesPerView: 4 },
                    }}
                >
                    {data.map((company) => (
                        <SwiperSlide key={company.company_id}>
                            <CardCompany data={company} />
                        </SwiperSlide>
                    ))}
                </Swiper>
                <div className="swiper-pagination-custom text-center" />
            </Container>
        </div>
    );
};

export default SimilarCompanies;